import CardType from "creditcards-types/type";
import unionpay from "creditcards-types/types/unionpay";

// Ref: https://github.com/bendrucker/creditcards-types/blob/v3.3.0/types/unionpay.js
export default CardType({
  name: unionpay.name,
  digits: [16, 19],
  pattern: /^(62|81)\d{14,17}$/,
  eagerPattern: /^(62|81)/,
  groupPattern: unionpay.groupPattern,
  luhn: unionpay.luhn,
});
